export const state = () => ({
  noScroll: false
});

export const mutations = {
  setNoScroll(state, value) {
    state.noScroll = value;
  }
};
